export interface ScriptSureDrugDoseResponse {
  MED_MEDID_DESC: string;
  ROUTED_MED_ID: number;
  GCN_SEQNO: number;
  MED_REF_DEA_CD: string;
  MED_ROUTED_MED_ID_DESC: string;
  MED_STATUS_CD: string;
  MED_STRENGTH: string;
  MED_STRENGTH_UOM: string;
  MED_DOSAGE_FORM_DESC: string;
  med_status_cd: string;
  epn: string;
  rxNorm: string;
  rxNormQualifier: string;
  MED_REF_GEN_DRUG_NAME_CD: string;
  MED_REF_FED_LEGEND_IND: string;
  MED_NAME_TYPE_CD: string;
  imk_preferred_ind: string;
  ndc: string;
}

export interface OtherDose {
  MED_MEDID_DESC: string;
  otherDescription: string;
  MED_DOSAGE_FORM_DESC: undefined;
  ndc: undefined;
  rxNorm: undefined;
}

export function isOtherDose(
  dose: ScriptSureDrugDoseResponse | OtherDose
): dose is OtherDose {
  return (dose as OtherDose).otherDescription !== undefined;
}



// WEBPACK FOOTER //
// ./src/models/scriptSure/scriptsureDrugDoseResponse.ts